import { DashBoardWidget } from '../dashboard-widget'
import React from 'react'
import widgetFollowUpCallMadeHoc, { widgetFollowUpCallMadeHocProps } from './follow-up-call-widget-hoc'
import { AnalyticDashboardWidget } from 'crm-types'

export const WidgetFollowUpCall: React.ComponentType<AnalyticDashboardWidget> = widgetFollowUpCallMadeHoc(
  (props: widgetFollowUpCallMadeHocProps) => (
    <DashBoardWidget
      avgDataPassedMonth={props.avgFollowUpCallThreeMonth}
      avgDataPassedMonthPerPerson={props.avgFollowUpCallPersonPassedMonth}
      avgPerPersonNumber={props.avgFollowUpCallCurrentMonthPerPerson}
      footerName={props.footerName}
      footerRender={props.threeMonthAgoFollowUpCall}
      isLoading={props.isLoading}
      onClickDetail={props.onClickDetail}
      refetch={props.refetchData}
      secondFooterName={props.footerNamePerPerson}
      secondFooterRender={props.avgFollowUpCallPassedMonthData}
      subtitle={props.mainCaption}
      subtitleSecondBlock={'Month date average'}
      title='Follow Up Calls'
      totalNumber={props.totalFollowUpCall}
    />
  )
)
